import styled from 'styled-components'
import { DatePicker } from 'antd'
import { calculateAlphaColor } from 'core/utils/colors'

const AntDatePickerStyled = styled(DatePicker)`
  &&& {
    input {
      :hover {
        border-color: ${props => props.theme.colors.color1.bg};
      }
      :focus {
        border-color: ${props => props.theme.colors.color1.bg}!important;
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
      :active {
        border-color: ${props => props.theme.colors.color1.bg};
        box-shadow: 0 0 0 2px ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
      }
    }
  }
`

export default AntDatePickerStyled
